import { render } from "./swipes.vue?vue&type=template&id=43b65a0c&scoped=true"
import script from "./swipes.vue?vue&type=script&lang=js"
export * from "./swipes.vue?vue&type=script&lang=js"

import "./swipes.vue?vue&type=style&index=0&id=43b65a0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43b65a0c"

export default script